export interface ScheduleRowLabels {
    amount: string;
    termLength: string;
}

export const SCHEDULE_ROW_LABELS: ScheduleRowLabels = {
    amount: "Amount",
    termLength: "Length",
};

/** A migrated schedule only carries what was left on its start date. */
export const MIGRATED_SCHEDULE_ROW_LABELS: ScheduleRowLabels = {
    amount: "Remaining balance",
    termLength: "Time left",
};
